import api, { handleApiResponse } from './api';
import { ApiResponse, PriceList, PriceListFormData } from '../types';

export const priceListService = {
  async getPriceListByProjectId(projectId: number): Promise<PriceList> {
    const response = await api.get<ApiResponse<PriceList>>(
      `/price-list/by-project/${projectId}`,
    );
    return handleApiResponse(response);
  },

  async createPriceList(request: PriceListFormData & { projectId: number }): Promise<PriceList> {
    const response = await api.post<ApiResponse<PriceList>>('/price-list', request);
    return handleApiResponse(response);
  },

  async updatePriceList(
    id: number,
    request: PriceListFormData,
  ): Promise<PriceList> {
    const response = await api.put<ApiResponse<PriceList>>(
      `/price-list/${id}`,
      request,
    );
    return handleApiResponse(response);
  },
};
